<template>
  <div class="container">
    <div v-if="!isMobile" class="pcWrapper">
      <div class="relationsWrapper">
        <div class="mapWrapper">
          <div v-if="noData" class="no-data-tip">
            <el-empty description="无此动态或动态已被删除">
              <el-button class="btn" type="primary" @click="goList">查看其它动态</el-button>
            </el-empty>
          </div>
          <div v-else class="dynamic-content" v-html="dynContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isMobile } from "@/utils/index";
  import { useGetDynamicListApi } from "@/api/useDynamicApi";

  export default {
    data() {
      return {
        isMobile: false,
        dynTitle: "", // 标题
        dynContent: "", // 富文本内容
        noData: false, // 添加无数据标志
      };
    },
    created() {
      this.getData();
    },
    mounted() {
      this.isMobile = isMobile();
      window.addEventListener("scroll", this.getScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.getScroll);
    },
    methods: {
      // 获取数据并处理
      async getData() {
        try {
          const dynId = this.$route.query.dynId;
          if (!dynId) {
            this.noData = true;
            return;
          }

          const res = await useGetDynamicListApi({
            id: dynId,
            pageNum: 1,
            pageSize: 10,
          });

          if (res && res.records) {
            const targetDynamic = res.records.find((item) => item.id === dynId);
            if (targetDynamic) {
              this.dynTitle = targetDynamic.title;
              // 处理富文本内容，特别是图片并排显示
              this.dynContent = this.processContent(targetDynamic.content);
              this.noData = false;
            } else {
              this.noData = true;
            }
          } else {
            this.noData = true;
          }
        } catch (error) {
          console.error("获取动态详情失败:", error);
          this.noData = true;
        }
      },

      // 处理富文本内容，优化图片显示
      processContent(content) {
        if (!content) return "";

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = content;

        // 查找所有包含多个图片的段落
        const paragraphs = tempDiv.querySelectorAll("p");
        paragraphs.forEach((p) => {
          // 查找段落中的所有图片
          const images = p.querySelectorAll("img");
          // 如果段落中有多个图片且它们在同一段落中
          if (images.length > 1) {
            // 为包含多张图片的段落添加特殊类名
            p.classList.add("multi-image-paragraph");
          }
        });

        return tempDiv.innerHTML;
      },

      goList() {
        this.$router.push({ path: "/dynamic" });
      },
      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 70) {
          this.$store.commit("TO_AfterScroll");
        } else {
          this.$store.commit("TO_AfterScroll_false");
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .relationsWrapper {
    background-color: #ffffff;

    .bannerWrapper {
      width: 100%;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .mapWrapper {
      padding: 70px 0px;
      width: 75%;
      display: flex;
      flex-direction: column;
      margin: auto;
    }
  }

  // 添加无数据提示样式
  .no-data-tip {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 16px;
    .btn {
      background-color: #b08d57;
      color: #fff;
      border: none;
    }
  }

  // 富文本内容样式
  .dynamic-content {
    ::v-deep h1 {
      text-align: center;
      font-size: 36px;
      color: #333;
    }

    ::v-deep h2 {
      text-align: center;
      font-size: 32px;
      color: #333;
    }

    ::v-deep p {
      text-indent: 2em;
      white-space: pre-line;
      text-align: left;
      font-size: 16px;
      font-weight: 350;
      line-height: 30px;
      color: #001f34;
    }

    ::v-deep img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 15px auto;
    }

    ::v-deep strong {
      font-weight: bold;
    }

    ::v-deep u {
      text-decoration: underline;
    }

    // 特别处理包含多张图片的段落
    ::v-deep .multi-image-paragraph {
      text-align: center;
      text-indent: 0;

      img {
        display: inline-block;
        margin: 0 10px;
        vertical-align: top;
        width: auto;
      }
    }

    // 处理富文本中设置的内联样式
    ::v-deep [style*="text-align: center"] {
      text-align: center;
    }

    ::v-deep [style*="width: 30%"] {
      img {
        width: 30%;
      }
    }
    ::v-deep [style*="width: 50%"] {
      img {
        width: 50%;
      }
    }
    ::v-deep [style*="width: 100%"] {
      img {
        width: 100%;
      }
    }
  }
</style>
